import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home-nav" }
const _hoisted_2 = { class: "nav-left" }
const _hoisted_3 = { class: "brand-block" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "brand-copy" }
const _hoisted_6 = {
  key: 1,
  class: "brand-name brand-name--with-logo"
}
const _hoisted_7 = {
  key: 2,
  class: "nav-tagline"
}
const _hoisted_8 = {
  class: "nav-right",
  ref: "navRightRef"
}
const _hoisted_9 = {
  key: 1,
  class: "offline-nav-badge"
}
const _hoisted_10 = {
  key: 0,
  class: "notify-badge"
}
const _hoisted_11 = { class: "user-name" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "avatar-initials"
}
const _hoisted_14 = {
  key: 3,
  class: "user-menu"
}
const _hoisted_15 = { class: "um-profile" }
const _hoisted_16 = { class: "um-avatar" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "um-avatar-initials"
}
const _hoisted_19 = { class: "um-identity" }
const _hoisted_20 = { class: "um-name" }
const _hoisted_21 = { class: "um-username" }
const _hoisted_22 = {
  key: 1,
  class: "user-menu-item user-menu-item--installed",
  style: {"cursor":"default","opacity":".6"}
}
const _hoisted_23 = { class: "info-modal" }
const _hoisted_24 = { class: "info-modal-header" }
const _hoisted_25 = { class: "info-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showMenuButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["menu-toggle", { open: _ctx.menuOpen }]),
            type: "button",
            "aria-label": "Menu",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-menu')))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1)
          ]))], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.siteLogoUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "brand-logo",
              src: _ctx.$resolveUrl(_ctx.siteLogoUrl),
              alt: _ctx.siteName
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.siteLogoUrl)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                ref: "brandNameRef",
                class: _normalizeClass(["brand-name", { 'is-overflow': _ctx.brandNameOverflow }])
              }, _toDisplayString(_ctx.siteName), 3))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.siteName), 1)),
          (_ctx.logoText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.logoText), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.showIaButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["ia-pill-btn", { 'ia-pill-btn--active': _ctx.iaMode }]),
            type: "button",
            "aria-label": "Modo IA",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('ia-mode')))
          }, [...(_cache[14] || (_cache[14] = [
            _createStaticVNode("<svg class=\"ia-sparkle\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-213492b6><defs data-v-213492b6><linearGradient id=\"ia-icon-grad\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" data-v-213492b6><stop offset=\"0%\" stop-color=\"#818cf8\" data-v-213492b6></stop><stop offset=\"50%\" stop-color=\"#34d399\" data-v-213492b6></stop><stop offset=\"100%\" stop-color=\"#fb923c\" data-v-213492b6></stop></linearGradient></defs><path d=\"M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z\" fill=\"url(#ia-icon-grad)\" data-v-213492b6></path><path d=\"M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z\" fill=\"url(#ia-icon-grad)\" opacity=\".8\" data-v-213492b6></path></svg><span class=\"ia-pill-label\" data-v-213492b6>Modo IA</span>", 2)
          ]))], 2))
        : _createCommentVNode("", true),
      (_ctx.isOffline && _ctx.isOfflineModeEnabled())
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 20 20",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M1 1l18 18M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55a10.94 10.94 0 0 1 5.17-2.39M10.71 5.05A16 16 0 0 1 22.56 9M1.42 9a15.91 15.91 0 0 1 4.7-2.88M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round"
              })
            ], -1),
            _createTextVNode(" Offline ", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.versionStore.hasNewVersion.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "nav-action-btn whats-new-btn",
            type: "button",
            "aria-label": "Novidades da versão",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('whats-new')))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("svg", {
              width: "15",
              height: "15",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polygon", { points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" })
            ], -1),
            _createElementVNode("span", { class: "whats-new-dot" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "nav-action-btn notify-btn",
        type: "button",
        "aria-label": "Notificacoes",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('notifications')))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["notification-icon", { 'has-alert': _ctx.notificationCount > 0 }])
        }, null, 2),
        (_ctx.notificationCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.notificationBadgeText), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "user-area",
        type: "button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args)))
      }, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userName), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["avatar", { 'has-img': !!_ctx.userAvatar }])
        }, [
          (_ctx.userAvatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userAvatar,
                alt: "perfil"
              }, null, 8, _hoisted_12))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.userInitials), 1))
        ], 2)
      ]),
      (_ctx.showUserMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_ctx.userAvatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.userAvatar,
                      alt: "perfil"
                    }, null, 8, _hoisted_17))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.userInitials), 1))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.userName), 1),
                _createElementVNode("span", _hoisted_21, "@" + _toDisplayString(_ctx.userUsername), 1)
              ])
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "user-menu-divider" }, null, -1)),
            _createElementVNode("button", {
              class: "user-menu-item",
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$emit('profile'); _ctx.showUserMenu = false})
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "8",
                  r: "4"
                }),
                _createElementVNode("path", { d: "M4 20c0-4 3.582-7 8-7s8 3 8 7" })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.settingsMenu')), 1)
            ]),
            _createElementVNode("button", {
              class: "user-menu-item",
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$emit('anotacoes'); _ctx.showUserMenu = false})
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
              ], -1),
              _createTextVNode(" Anotações ", -1)
            ]))]),
            (_ctx.isInstallable && !_ctx.isInstalled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "user-menu-item user-menu-item--install",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.promptInstall(); _ctx.showUserMenu = false})
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "3",
                      width: "18",
                      height: "18",
                      rx: "3"
                    }),
                    _createElementVNode("path", { d: "M12 8v8M8 12l4 4 4-4" })
                  ], -1),
                  _createTextVNode(" Instalar como app ", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.isInstalled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1),
                  _createTextVNode(" App instalado ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "user-menu-item",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.showInfoModal = true; _ctx.showUserMenu = false})
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "8",
                  x2: "12",
                  y2: "8.5",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "12",
                  x2: "12",
                  y2: "16",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Mais informações ", -1)
            ]))]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "user-menu-divider" }, null, -1)),
            _createElementVNode("button", {
              class: "user-menu-item user-menu-item--danger",
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8"
              }, [
                _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
                _createElementVNode("polyline", { points: "16 17 21 12 16 7" }),
                _createElementVNode("line", {
                  x1: "21",
                  y1: "12",
                  x2: "9",
                  y2: "12"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.logout')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.showInfoModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "info-overlay",
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showInfoModal = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "info-modal-icon" }, [
                    _createElementVNode("svg", {
                      width: "22",
                      height: "22",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "8",
                        x2: "12",
                        y2: "8.5",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "12",
                        x2: "12",
                        y2: "16",
                        "stroke-linecap": "round"
                      })
                    ])
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "info-modal-title" }, "Sobre este sistema", -1)),
                  _createElementVNode("button", {
                    class: "info-modal-close",
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showInfoModal = false))
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))])
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "info-modal-body" }, [
                  _createElementVNode("p", null, "Respondendo uma dúvida que você talvez tenha: eu, Gustavo, fiz esse sistema do zero. Não é um sistema de terceiros pirateado, é um sistema autoral que vem sendo atualizado com o feedback de cada um de vocês!"),
                  _createElementVNode("p", null, "Esse sistema vem sendo desenhado com o intuito de ajudar a todos nós para que cresçamos juntos como equipe e por esse motivo o feedback de vocês é muito importante!")
                ], -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "info-modal-btn",
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showInfoModal = false))
                  }, "Entendido!")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    ], 512)
  ]))
}